import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export function GuestLandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Load CSS
    const styleLink = document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.href = '/landing/css/style.css';
    document.head.appendChild(styleLink);

    const bootstrapLink = document.createElement('link');
    bootstrapLink.rel = 'stylesheet';
    bootstrapLink.href = '/landing/bootstrap/4/css/bootstrap.min.css';
    document.head.appendChild(bootstrapLink);

    const fontAwesomeLink = document.createElement('link');
    fontAwesomeLink.rel = 'stylesheet';
    fontAwesomeLink.href = '/landing/fontawesome5/css/all.min.css';
    document.head.appendChild(fontAwesomeLink);

    return () => {
      document.head.removeChild(styleLink);
      document.head.removeChild(bootstrapLink);
      document.head.removeChild(fontAwesomeLink);
    };
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#000',
      color: '#fff',
      fontFamily: 'Arial, sans-serif'
    }}>
      {/* Header */}
      <div style={{
        padding: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#000'
      }}>
        <img
          src="/landing/images/logo_sport_w.png"
          alt="Level Sport"
          height="40"
          onError={(e) => {
            e.currentTarget.src = '/logotype-white.png';
          }}
        />
        <button
          onClick={() => navigate('/')}
          style={{
            backgroundColor: '#10b981',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Войти
        </button>
      </div>

      {/* Hero Section */}
      <div style={{
        textAlign: 'center',
        padding: '60px 20px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '20px',
          color: '#10b981'
        }}>
          Level Premium
        </h1>
        <p style={{
          fontSize: '24px',
          marginBottom: '40px',
          color: '#d1d5db'
        }}>
          Фитнес • Бассейн • Теннис • SPA • Ресторан
        </p>

        {/* Image Gallery Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          marginTop: '40px'
        }}>
          {[
            { img: 'gym.webp', title: 'Тренажерный зал' },
            { img: '2.webp', title: 'Фитнес студия' },
            { img: '3.webp', title: 'Массажные кабинеты' },
            { img: '4.webp', title: 'Beach Club' },
            { img: '5.webp', title: 'Теннисные корты' },
            { img: '6.webp', title: 'Салон красоты' },
            { img: '7.webp', title: 'SPA зона' },
            { img: '1.webp', title: 'Ресторан' }
          ].map((item, idx) => (
            <div key={idx} style={{
              position: 'relative',
              borderRadius: '12px',
              overflow: 'hidden',
              aspectRatio: '16/9',
              backgroundColor: '#1f2937'
            }}>
              <img
                src={`/landing/images/${item.img}`}
                alt={item.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                padding: '15px',
                background: 'linear-gradient(to top, rgba(0,0,0,0.8), transparent)',
                color: 'white',
                fontSize: '18px',
                fontWeight: 'bold'
              }}>
                {item.title}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <button
          onClick={() => navigate('/')}
          style={{
            marginTop: '60px',
            backgroundColor: '#f59e0b',
            color: 'white',
            padding: '20px 60px',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '20px',
            fontWeight: 'bold',
            boxShadow: '0 4px 6px rgba(0,0,0,0.3)'
          }}
        >
          ЗАБРОНИРОВАТЬ КАРТУ
        </button>
      </div>

      {/* Contact Section */}
      <div style={{
        backgroundColor: '#1f2937',
        padding: '60px 20px',
        marginTop: '40px'
      }}>
        <div style={{
          maxWidth: '800px',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          <h3 style={{
            fontSize: '32px',
            color: '#f59e0b',
            marginBottom: '30px'
          }}>
            LEVEL SPORT
          </h3>

          <div style={{ marginBottom: '20px' }}>
            <p><strong>Телефон (Спорт):</strong> +7 (978) 735-85-65</p>
            <p><strong>Телефон (Теннис):</strong> +7 (978) 978-99-91</p>
            <p><strong>Телефон (Отдых):</strong> +7 (978) 851-93-00</p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p><strong>Адрес:</strong></p>
            <p>г. Симферополь, пр. Победы, 173а</p>
          </div>

          <div style={{ marginBottom: '30px' }}>
            <p><strong>Режим работы:</strong></p>
            <p>Пн-Вс: 07:00 - 23:00</p>
          </div>

          {/* Social Buttons */}
          <div style={{
            display: 'flex',
            gap: '15px',
            justifyContent: 'center',
            marginTop: '30px'
          }}>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textDecoration: 'none',
                fontSize: '24px'
              }}
            >
              📷
            </a>
            <a
              href="https://vk.com"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textDecoration: 'none',
                fontSize: '24px'
              }}
            >
              V
            </a>
            <a
              href="https://t.me"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255,255,255,0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                textDecoration: 'none',
                fontSize: '24px'
              }}
            >
              ✈️
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
